import React from 'react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEventThrottled, PRODUCT_EVENT_PARAMS } from '../utils/metaPixel';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  variant?: 'solid' | 'outline';
  className?: string;
};
export function CtaButton({
  href,
  children,
  external = false,
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-md px-5 py-3.5 text-center font-display text-[17px] font-bold uppercase tracking-wide leading-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-out active:scale-[0.985] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal sm:text-xl';
  const styles = variant === 'solid' ? 'bg-gold text-charcoal shadow-gold hover:bg-gold-soft' : 'border border-gold/50 bg-transparent text-gold hover:bg-gold/10';
  const isCheckout = href === CHECKOUT_URL;
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEventThrottled('InitiateCheckout', PRODUCT_EVENT_PARAMS);
    }
  };
  return <a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`${base} ${styles} ${className}`} data-id="element-26" data-mp="3ewswvxcn5pty">
      {children}
    </a>;
}